/* tslint:disable */
/* eslint-disable */
export enum ClinicalDataStatus {
  INPROGRESS = 0,
  COMPLETED = 1,
  ERROR = 2
}
